<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="col-md-12 px-0">
                <h3>Score</h3>
            </div>
        </div>

        <div class="tab p-0">
            <router-link class="text-decoration-none tablinks h2 m-0"  to="/results" >Individual</router-link>
            <router-link class="text-decoration-none tablinks h2 m-0 active" to="/results/team">Team</router-link>
        </div>
        <div class="tabcontent tabcontent-border-style" v-if="scores.length > 0">

<!--            <div v-if="isSearch" class="fullInputs mb-4 pt-3">-->
<!--                <div class="twoInputs">-->
<!--                    <div class="btnInsideInput">-->
<!--                        <input type="text" id="free_search" class="form-control" v-model="search"-->
<!--                               placeholder="Search" autocomplete="off"-->
<!--                               @input="searchScore" maxlength="50">-->

<!--                        <button @click="searchBackEndHandler" ref="buttonSearch">-->
<!--                            <img src="../../../assets/images/SearchIcon.png" alt="">-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="oneInput">-->
<!--                    <select id="filter_dates" class="form-select" v-model="sort" @change="getCompetitionsScore">-->
<!--                        <option value="false" selected disabled >Sort by Date</option>-->
<!--                        <option value="asc">Oldest</option>-->
<!--                        <option value="desc">Latest</option>-->
<!--                    </select>-->
<!--                </div>-->
<!--            </div>-->
            <div class="table-container" >
                <div v-if="!isSearch" class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchScore" maxlength="50">

                            <button @click="searchBackEndHandler" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getCompetitionsScore">
                            <option value="false" selected disabled >Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>
                <TableComponent :tbody="scores" @sort="SortOrganization" :thead="thead" :keys="keys" name="score" model="scoreTeams"
                                updateUrl="/edit-scores" @update="updateScore"/>

                <div class="paginationLink">
                    <pagination :data="laravelData" @pagination-change-page="getCompetitionsScore" :limit="3">
                        <template #prev-nav>
                            <span>Previous</span>
                        </template>
                        <template #next-nav>
                            <span>Next</span>
                        </template>
                    </pagination>
                </div>
            </div>
        </div>

        <div class="tabcontent tabcontent-border-style" v-else>
            <div v-if="!isSearch" class="fullInputs mb-4 pt-3">
                <div class="twoInputs">
                    <div class="btnInsideInput">
                        <input type="text" id="free_search" class="form-control" v-model="search"
                               placeholder="Search" autocomplete="off"
                               @input="searchScore" maxlength="50">

                        <button @click="searchBackEndHandler" ref="buttonSearch">
                            <img src="../../../assets/images/SearchIcon.png" alt="">
                        </button>
                    </div>
                </div>
                <div class="oneInput">
                    <select id="filter_dates" class="form-select" v-model="sort" @change="getCompetitionsScore">
                        <option value="false" selected disabled >Sort by Date</option>
                        <option value="asc">Oldest</option>
                        <option value="desc">Latest</option>
                    </select>
                </div>
            </div>
            <div class="styleDataNotFound">
                <h3 v-if="!isSearch">You Don't Have Any Results Yet</h3>
                <h3 v-else>No Data</h3>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";

    export default {
        name:'userscore-pageTeam',
        data(){
            return {
                thead:['Competition Name' , 'Number Of Participants'],
                keys:['name' , 'number_of_participants'],
                permissions: [],
                scores: [],
                filteredArray: [],
                originalScores: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false,
                isSearch:false,
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted(){
            await this.$store.dispatch('activeTap', 'results');
            this.getCompetitionsScore();
        },
        methods:{
            getCompetitionsScore: async function (page=1) {
                try {
                    const response = await score.indexTeam(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    this.scores = response.data.data;
                    this.laravelData = response.data;
                    this.originalScores = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }

            },
            updateScore(e) {
                let filteredData = this.scores.filter(function (data) {
                    return data.id != e;
                });
                this.scores = filteredData;
            },
            searchScore(e) {
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                //
                // searchedData = this.originalScores.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0 || (data.domain != null ? data.domain.toLowerCase().indexOf(serachedValue) >= 0 : false));
                // this.scores = searchedData;
                //
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
            },
            async searchBackEndHandler(searchFlag = false) {
                await this.getCompetitionsScore();
            },
            SortOrganization() {
                let status = !this.state;
                this.originalScores.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .styleDataNotFound{
         display: flex;
         flex-wrap: wrap;
         justify-content: center;
         align-items: center;
         height: 80%;
     }
</style>